export default __webpack_public_path__ + "static/media/arrow.ed0d2280.svg";